import React from "react";
import { useDrop } from "react-dnd";
import Coin from "../components/Coin";
import { BINARY_FONT, COLOR_HIGHLIGHTED } from "../defaults";
import coin_1 from "../images/coin_1.png";
import coin_16 from "../images/coin_16.png";
import coin_2 from "../images/coin_2.png";
import coin_32 from "../images/coin_32.png";
import coin_4 from "../images/coin_4.png";
import coin_8 from "../images/coin_8.png";
import "./Box.css";


const coinImages = [coin_32, coin_16, coin_8, coin_4, coin_2, coin_1];

/* 
This component implements a box into which coins can be dropped.
Parts of it were created with the help of LLMs.
*/
function BinaryBoxDestination({ id, droppedCoins, onDropCoin, coinSize }) {
  const [, drop] = useDrop({
    accept: "coin",
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDropCoin(item.id, id); // item.id is 2d-array. item[0] is index of coin that was dropped, that index corresponds to a char (e.g. in Roman 2 = 'X'). id is the index of the box it was dropped in.
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  });

  const coinStyle = {
    width: coinSize+"dvh",
    height: coinSize+"dvh",
    display: "flex",
    justifyContent: "center",
    zIndex: 1,
    marginLeft: "2dvh",
    marginRight: "2dvh",
  };

  const textStyle = {
    fontFamily: BINARY_FONT,
    fontSize:"5dvh", 
    color: COLOR_HIGHLIGHTED,
    filter: "drop-shadow(0.3svh 0.3svh 0.3svh rgba(0, 0, 0, 0.5))" // Using textShadow in combination with fontWeight : "bold" looks weird on iPads. Using filter circumvents this issue.
  };

  const boxStyle = {
    display: "flex",
    flexDirection: "row",
    width: "80dvh",
    height: "20dvh",
    zIndex: 0,
    filter: "drop-shadow(0svh 0svh 0.6svh rgba(0, 0, 0, 0.5))",
    borderRadius: "0.25em",
    alignItems: "center",
    justifyContent: "center",
  };

  const dropStyle = {
    maxWidth: "80dvh",
    maxHeight: "35dvh",
    backgroundColor: "none",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignContent: "center",
  };

  return (
    <div ref={drop} style={dropStyle}>
      <div alt="BinaryBox" className="binary-box" style={boxStyle}>
        <React.Fragment key={id}>
          {(Array.from({ length: 6 }).map((_, coinId) => {
            const notLeadingZero = droppedCoins.slice(0, coinId + 1).includes(1); /* Partially LLM-generated line. If a coin with lower coinId than current has been dropped (i.e. there is a 1 to the left somewhere), then strengthen all numbers to the right. */
            return (
              <div style={{display: "flex", flexDirection: "column"}}>
                {droppedCoins[coinId] === 1 && <span style={coinStyle}><Coin key={[coinId, 0]} id={[coinId, 0]} coinImage={coinImages[coinId]}/></span>}
                {droppedCoins[coinId] === 0 && <span key={coinId} style={{...coinStyle, opacity: "0.3"}}><img style={{width: "100%", height: "100%"}} src={coinImages[coinId]} alt="coin"/></span>}
                <span style={{...textStyle, opacity: notLeadingZero ? "1" : "0.5", fontWeight: notLeadingZero ? "bold" : "normal", color: notLeadingZero ? COLOR_HIGHLIGHTED : "white"}}>{droppedCoins[coinId]}</span> 
              </div>
            )})
          )}
        </React.Fragment>
      </div>
    </div>
  );
}

export default BinaryBoxDestination;
